"use client"

import React from 'react';
import { useTranslations } from 'next-intl';
import { motion } from 'framer-motion';
import { theme } from '@/styles/theme';
import config from '@/config';
import { useRouter } from 'next/navigation';
import { useParams } from 'next/navigation';

const CTA = ({ translationKey }) => {
  const t = useTranslations(translationKey);
  const featuresCount = t.raw('features').length;
  const router = useRouter();
  const params = useParams();

  return (
    <section className={`py-12 sm:py-16 lg:py-20 ${theme.colors.background.primary}`}>
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        {/* 卡片容器 */}
        <div className={theme.components.card.gradient}>
          <div className={`
            ${theme.components.card.content}
            ${theme.components.card.glow}
            px-8 py-10 overflow-hidden lg:px-24 md:py-20
          `}>
            {/* 背景效果 */}

            {/* 内容 */}
            <div className="relative z-10">
              <motion.div 
                className="max-w-2xl mx-auto text-center"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
              >
                <h2 className={`text-3xl font-bold sm:text-4xl xl:text-5xl ${theme.colors.text.primary}`}>
                  {t('title')}
                </h2>
              </motion.div>

              <motion.ul 
                className="flex flex-col items-center justify-center mt-8 space-y-5 sm:mt-12 lg:mt-16 md:flex-row md:space-y-0 md:space-x-12"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
              >
                {[...Array(featuresCount)].map((_, index) => (
                  <motion.li 
                    key={index} 
                    className={`flex items-center ${theme.colors.text.brand}`}
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                  >
                    <svg 
                      className="w-6 h-6" 
                      xmlns="http://www.w3.org/2000/svg" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth="2" 
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
                      />
                    </svg>
                    <span className={`ml-3 text-lg font-bold ${theme.colors.text.primary}`}>
                      {t(`features.${index}`)}
                    </span>
                  </motion.li>
                ))}
              </motion.ul>

              <motion.div 
                className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <motion.a
                  onClick={() => router.push(`/${params.locale}/app`)}
                  className={`${theme.buttons.primary} cursor-pointer`}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {t('buttonText')}
                </motion.a>
                <p className={`text-sm ${theme.colors.text.tertiary}`}>
                  {t('disclaimer')}
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;